import React, { ReactElement, useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { LiveProps } from '../../../LiveContainer';
import { useDispatch } from 'react-redux';
import { actions } from '../../../liveSlice';
import { Image } from 'react-bootstrap';
import { ResponseAudience } from '../../../../../services/api/models/response/responseAudience';
import {
  useGetGiftTopAudienceMutation,
  useGetLiveAudiencesMutation,
} from '../../../../../services/api/apiProvider';
import { ImageCustom } from '../../../../../common/components/ImageCustom';
import giftTopIcon from '../../../../../assets/svg/gift_top.svg';
import { getLevelColor } from '../../../../../common/utils/utils';
import haveNoAudience from '../../../../../assets/png/have-no-audience.png';

const LiveAudienceMobileModal = (props: LiveProps): ReactElement => {
  const dispatch = useDispatch();
  const [audiences, setAudiences] = useState<ResponseAudience[]>([]);
  const [getAudiences] = useGetLiveAudiencesMutation();
  const [getTopAudience] = useGetGiftTopAudienceMutation();

  const UPDATE_CYCLE = 15000;

  /**
   * Fetch audiences data from API.
   */
  const fetchAudiencesData = () => {
    if (props.liveState.liveData) {
      getAudiences(props.liveState.liveData.id)
        .unwrap()
        .then((data) => {
          setAudiences(data);
        });
    }
  };

  /**
   * Get GiftTop user
   * @param audience
   */
  const fetchGiftTopAudience = () => {
    if (
      props.liveState.giftTopAudience === undefined &&
      props.liveState.liveData
    ) {
      // update gift top
      getTopAudience(props.liveState.liveData?.id)
        .unwrap()
        .then((listAudience) => {
          if (listAudience.length > 0) {
            props.setGiftTopAudience(listAudience[0]);
          } else {
            props.setGiftTopAudience(undefined);
          }
        });
    }
  };

  useEffect(() => {
    const timer = setInterval(() => {
      if (props.liveState.isInLive && props.liveState.liveData) {
        fetchAudiencesData();
        fetchGiftTopAudience();
        //listenChannelMessage();
      }
    }, UPDATE_CYCLE);
    return () => {
      clearInterval(timer);
    };
  }, [props.liveState.isInLive]);

  const renderAudiences = () => {
    return (
      <ul className="list-audi">
        {/* Gift Top audience */}
        {props.liveState.giftTopAudience !== undefined ? (
          <li className="d-flex list-audi__item">
            <div className="d-flex flex-column gift-top">
              <div className="audi-item__avatar_top">
                <Image
                  src={props.liveState.giftTopAudience.picture.uri}
                  style={{ width: '48px', height: '48px' }}
                />
                <Image
                  src={giftTopIcon}
                  className="audi-item__avatar_top"
                ></Image>
              </div>
            </div>
            <div className="d-flex flex-column audi-item__info">
              <div className="d-flex align-items-center">
                <div className="d-flex flex-column">
                  <div className="audi-item__info__name">
                    {props.liveState.giftTopAudience.loginId}
                  </div>
                </div>
                <div className="d-flex flex-column">
                  <span
                    className="audi-item__info__level"
                    style={{
                      backgroundColor: getLevelColor(
                        props.liveState.giftTopAudience.level,
                      ),
                    }}
                  >{`Lv.${props.liveState.giftTopAudience.level}`}</span>
                </div>
                <div className="d-flex flex-column">
                  <span className="audi-item__info__top_badge">{`ギフトトップ`}</span>
                </div>
              </div>
            </div>
          </li>
        ) : (
          <></>
        )}

        {/* List audience */}
        {audiences.map((au) => (
          <li key={au.id} className="d-flex list-audi__item">
            <div className="d-flex flex-column">
              <div className="audi-item__avatar">
                <ImageCustom src={au.picture.uri} />
              </div>
            </div>
            <div className="d-flex flex-column audi-item__info">
              <div className="d-flex align-items-center">
                <div className="d-flex flex-column">
                  <div className="audi-item__info__name">{au.loginId}</div>
                </div>
                <div className="d-flex flex-column">
                  <span
                    className="audi-item__info__level"
                    style={{ backgroundColor: getLevelColor(au.level) }}
                  >{`Lv.${au.level}`}</span>
                </div>
              </div>
            </div>
          </li>
        ))}
      </ul>
    );
  };
  const handleCloseModal = () => {
    dispatch(actions.toggleAudienceMobileModal(false));
  };
  return (
    <Modal
      show={props.liveState.isShowLiveAudienceMobileSideModal}
      onHide={handleCloseModal}
      backdrop="static"
      keyboard={false}
      centered
      scrollable={true}
    >
      <Modal.Header closeButton>
        <Modal.Title> リスナー</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {audiences.length > 0 ? (
          <>{renderAudiences()}</>
        ) : (
          <ImageCustom style={{ width: '100%' }} src={haveNoAudience} />
        )}
      </Modal.Body>
    </Modal>
  );
};
export default LiveAudienceMobileModal;
